import { useState, useRef, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import SeccionPropuestas from "../components/admin/SeccionPropuestas"

export default function Generador() {
  const { user }  = useAuth()
  const { state } = useLocation()

  return (
    <div style={{ minHeight:"100vh", background:"#0a1929" }}>
      <header style={{ background:"#0a1929", borderBottom:"1px solid #1e3a5f", padding:"16px 32px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <Link to="/">
          <img src="/logos/logo-lowtravel.png" alt="Low Travel" style={{ height:36 }} />
        </Link>
        <span style={{ color:"#c9a84c", fontSize:"0.85rem", fontWeight:700 }}>Generador de Propuestas</span>
      </header>
      <div style={{ padding:"32px" }}>
        <SeccionPropuestas initialForm={state?.prefill} cotizacionContext={state?.cotizacionContext} />
      </div>
    </div>
  )
}
